import {getTradeCollectionPath, type TradeDb} from '@cp/model';
import {collection, CollectionReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

export function getTradeCollection(uid: string): CollectionReference<TradeDb> {
  return collection(firebaseFirestore, getTradeCollectionPath(uid)) as CollectionReference<TradeDb>;
}
